import React from "react";
import Seo, { breadcrumbSchema, faqSchema } from "@/components/Seo";
import PageHero from "@/components/PageHero";
import { BookButton } from "@/components/ui-bits";
import { Accordion, AccordionItem, AccordionTrigger, AccordionContent } from "@/components/ui/accordion";
import { FAQS, IMAGES, HOTEL } from "@/lib/site";

export default function Faq() {
  return (
    <>
      <Seo
        title="Frequently Asked Questions | Regency Inn & Suites, Pittsburg KS"
        description="Answers about check-in, breakfast, pets, parking, WiFi, extended-stay rates, accessibility and more at Regency Inn & Suites in Pittsburg, Kansas."
        path="/faq"
        image={IMAGES.lobby}
        schema={[
          breadcrumbSchema([{ name: "Home", path: "/" }, { name: "FAQ", path: "/faq" }]),
          faqSchema(FAQS),
        ]}
      />
      <PageHero
        eyebrow="Questions & Answers"
        title="Everything you want to know."
        subtitle="Quick, honest answers to the questions our guests ask most. Still curious? Our 24-hour front desk is always happy to help."
        image={IMAGES.lobby}
        crumbs={[{ name: "Home", path: "/" }, { name: "FAQ", path: "/faq" }]}
      />

      <section className="bg-bone py-20 lg:py-28">
        <div className="max-w-3xl mx-auto px-6">
          <Accordion type="single" collapsible className="w-full" data-testid="faq-accordion">
            {FAQS.map((f, i) => (
              <AccordionItem key={i} value={`item-${i}`} className="border-b border-stone/20">
                <AccordionTrigger className="text-left font-serif text-xl text-forest hover:text-amber-deep py-6" data-testid={`faq-q-${i}`}>
                  {f.q}
                </AccordionTrigger>
                <AccordionContent className="text-stone leading-relaxed text-[15px] pb-6">{f.a}</AccordionContent>
              </AccordionItem>
            ))}
          </Accordion>

          <div className="mt-14 text-center">
            <p className="text-stone mb-5">Didn't find your answer?</p>
            <div className="flex flex-wrap justify-center gap-4">
              <a href={HOTEL.phoneHref} data-testid="faq-call" className="inline-flex items-center rounded-full bg-forest text-bone px-8 py-4 text-sm font-medium hover:bg-amber transition-colors">
                Call {HOTEL.phone}
              </a>
              <BookButton label="Book Your Stay" variant="ghost" testid="faq-book" className="text-forest" />
            </div>
          </div>
        </div>
      </section>
    </>
  );
}
